import { Workflow } from 'src/app/modules/core/store/models/workflow.model';
import { DocumentSchema } from 'src/app/modules/core/store/models/document.model';
import { Collaborator } from 'src/app/modules/core/store/models/content-share.model';
import { FilterGroup } from './filters.model';

export interface Dataset {
  uId?: string | null;
  name: string | null;
  defaultColor: string;
  opacity: number;
  markerName?: string;
  markerSize?: string;
  iconPath: string;
  isCustomIcon: boolean;
  customMarkerImage?: string;
  customMarkerImageHeight?: number;
  customMarkerImageWidth?: number;
  createdOn: string | null;
  updatedOn: string | null;
  lastEditedByName: string | null;
  lastEditedById: string | null;
  isActive: boolean;
  schema: DocumentSchema;
  type: DatasetType;
  subtype: DatasetSubtype;
  collaborators: Collaborator[];
  systemDataTableName?: string;
  workflow?: Workflow;
  isSubscribedRecord?: boolean;
  assetsImpactedDistanceDefaultInImperialUnits?: number;
  assetsImpactedDistanceDefaultInMetricUnits?: number;
  organizationUId?: string;
  sourceOrgUId?: string;
  sourceDatasetUId?: string;
  sourceTableName?: string;
  useTileServer?: boolean;
  assetsTargetDatasets?: string;
  includeInDataMart?: boolean;
  includeInResponseMetrics?: boolean;
  includeInWorkflowInsights?: boolean;
  proximityRadiusInMeters?: number;
  mappingsFrom?: DatasetMappings[];
  securityFilters?: DatasetSecurityFilter[];
  hasTranslations: boolean;
  documentRetentionMonths: number;
  retentionDateField?: string;
}

export type DatasetsSet = { [datasetUId: string]: Dataset };

export enum DatasetType {
  None = 0,
  Alerts = 1,
  Assets = 2,
  PointOfInterest = 3,
  FloorPlan = 4,
  Camera = 5,
  Alarm = 6,
  DistributionList = 7,
  Task = 8,
  Incident = 9,
  Default = 10,
  Metrics = 11,
  Geofence = 12,
  ActivityLog = 13,
  Picklist = 14,
  ProfilePreferences = 15,
  UserSubscriptions = 16,
  SystemLog = 17
}

export enum DatasetSubtype {
  None = 0,

  // alert sub-types
  Intelligence = 1,
  Rating = 2,
  Weather = 3,
  TropicalCyclone = 4,
  Wildfire = 5,
  Earthquake = 6,
  MobileEvent = 21,
  PowerOutage = 24,
  PowerOutageV2 = 25,
  Tours = 39,
  SevenPAlert = 47,

  // asset sub-types
  Facility = 7,
  Person = 8,
  Shipment = 9,
  TravelItinerary = 10,
  Assignment = 16,
  Flight = 23,
  Vehicle = 26,
  SamsaraDriver = 31,
  Job = 32,
  Schedule = 33,
  HorizonPerson = 28,
  Cardholder = 43,
  Transports = 45,
  Device = 46,

  // incident sub-types
  Incident = 11,
  Timeline = 12,
  InvolvedParty = 13,
  Issue = 14,
  StatusUpdate = 15,

  // camera sub-types
  Traffic = 17,
  AgentVmsIntegration = 18,
  Single = 35,
  Group = 36,
  Camera = 40,

  // POI sub-types
  Area = 41,
  Door = 42,

  // alarm sub-types
  GenetecEvent = 44,

  // System Log sub-types
  MassNotification = 27,

  HorizonLocations = 29,
  HorizonAirlines = 30,
  HorizonCategory = 34,
  HorizonLocationIntelRatings = 37,
  HorizonGeospatialThreatZone = 38
}

export interface DatasetsRequest {
  skip: number;
  take: number;
  where?: string;
  sortField?: string;
  sortDirection: any;
  include?: string;
  includeWorkflow?: boolean;
  skipChildren?: boolean;
  includeTranslations?: boolean;
  datasetUIds?: string[];
}

export interface DatasetMappings {
  uId?: string | null;
  targetDatasetUId?: string | null;
  targetMappings?: FieldMapping[] | null;
}

export interface FieldMapping {
  fromField: string;
  toField: string;
  configuration?: any;
  organizationUId?: string;
  sourceOrgUId?: string;
  sourceDatasetUId?: string;
}

export interface DatasetRegion {
  uId: string;
  name: string;
  isActive: boolean;
}

export interface DatasetSecurityFilter {
  uId: string;
  datasetUId: string;
  filterGroup?: FilterGroup;
  groupUIds?: string[];
  userUIds?: string[];
}

export interface EnumRegistration {
  uId: string;
  name: string;
  updatedOn: string;
  updatedById: string;
  updatedByName: string;
  isActive: boolean;
  enumValues: EnumRegistrationValue[];
}

export interface EnumRegistrationValue {
  uId: string;
  enumRegistrationUId: string;
  name: string;
  value: number;
  isActive: boolean;
}
